import { Pipe, PipeTransform } from '@angular/core';
import { Order } from '../../entity/order';

@Pipe({name: 'orders_filter'})
export class OrdersFilterPipe implements PipeTransform {
    transform(items: Order[], search: string): any {
        if (!items || !search) {
            return items;
        }
        // filter items array, items which match and return true will be kept, false will be filtered out
        return items.filter(item => this.match(item,search));
    }

    match(item: Order, search: string): boolean {
        let selected = false;
        if(item.number.toLowerCase().indexOf(search.toLowerCase())>-1){
            selected = true;
        }

        /*let date = new Date(item.receptionDate)
        let day = date.getDate();
        let month = date.getMonth()+1;
        let month_str = ""+month;
        if(month < 10) {
            month_str = "0"+month;
        }
        let year = date.getFullYear();
        let formattedDate = day+"/"+month_str+"/"+year;
        if(formattedDate.toLowerCase().indexOf(search.toLowerCase())>-1){
            selected = true;
        }*/

        if (item.infos.producer.identity !== undefined) {
            if (item.infos.producer.identity.toLowerCase().indexOf(search.toLowerCase()) > -1) {
                selected = true;
            }
        }
        if (item.infos.producer.businessName !== undefined) {
            if (item.infos.producer.businessName.toLowerCase().indexOf(search.toLowerCase()) > -1) {
                selected = true;
            }
        }
        return selected;
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/pipes/orders-filter.pipe.ts